import { format, isSameDay, parseISO } from 'date-fns';
import { Event } from '../../../../services';
import { getDateFnsLocale } from '../../../utils';
import { getEventDateTimeFormat } from './getEventDateTimeFormat';

export const eventDateTime = (event: Pick<Event, 'startAt' | 'endAt'>): string => {
  const { startAt, endAt } = event;

  const locale = getDateFnsLocale();
  const dateFormat = getEventDateTimeFormat();

  const startDate = parseISO(startAt);

  const start = format(startDate, dateFormat, { locale });

  if (!endAt) {
    return start;
  }

  const endDate = parseISO(endAt);

  const end = isSameDay(startDate, endDate)
    ? format(endDate, 'HH:mm')
    : format(endDate, dateFormat, { locale });

  return `${start} - ${end}`;
};
